<div fxLayout="column"
     fxLayoutAlign="start center"
     *ngIf="bankLinkStatus === BankLinkStatus.Unlinked || !bankLinkStatus">
  <p class="text">For faster access to funds, securely link and verify your bank with <a href="https://plaid.com/" target="_blank"><b>Plaid</b>&trade;</a>.</p>
  <div>
    <button mat-flat-button
            color="primary"
            (click)="onClickLinkBank()">
      <mat-icon>link</mat-icon>
      Link your bank
    </button>
  </div>
